/* eslint-disable react/no-unused-class-component-methods */
'use strict';

import React, { Component } from 'react'

import { TwitterPicker as ColorPickerSecondary } from 'react-color'
import { HuePicker as ColorPicker }              from 'react-color'

import AutoCompletedField from '@Pure/AutoCompletedField'
import FormElement        from '@/Form/toolkit/FormElement'
import Form               from '@/Form/toolkit/Form'
import Loader             from '@Pure/Loader'
import Link               from '@Pure/Link'

const { app } = window;

export default class ColorForm extends Component
{
	state =
	{
		form_data: { },
		status_messages: { },
		colors:
		{
			main: ''
		}
	};

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props;

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		if (app.state.session.EC)
		{
			component.handleSessionChange();
		}
	}

	componentWillUnmount()
	{
		const component = this, props = this.props;

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});
	}

	handleColorChange = (color, event) =>
	{
		const component = this, props = this.props;

		let form_data = component.state.form_data;

		form_data['color[main]'] = color.hex.toUpperCase();

		component.state.colors.main = color.hex;

		component.setState(
		{
			form_data: form_data
		});
	}

	handleSessionChange = (source) =>
	{
		const component = this, props = this.props;

		let form_data = component.state.form_data || { };

		if (source && source.label === 'themeColorChange') return;

		component.setState(
		{
			form_data:
			{
				...form_data,

				'color[main]': app.state.session.EC?.color?.main
			},

			error: undefined
		});
	}

	handleChange = (e, data) =>
	{
		const component = this, props = this.props;

		var form_data       = this.state.form_data;
		var status_messages = this.state.status_messages;

		status_messages[data.name] = status_messages[data.name] || { };

		status_messages[data.name].error   = undefined;
		status_messages[data.name].info    = undefined;
		status_messages[data.name].warning = undefined;

		form_data[data.name] = data.value;

		component.setState(
		{
			form_data: form_data,
			error: undefined
		});
	}

	handleFailure = (response) =>
	{
		var status_messages = Object.assign({ }, this.state.status_messages);

		Object.keys(response.fields || { }).forEach(function (field, index)
		{
			status_messages[field] = response.fields[field];
		});

		this.setState(
		{
			error: response.error,
			warning: response.warning,
			status_messages: status_messages,
			loading: false
		});
	}

	handleValidate = (response) =>
	{
		const component = this, props = this.props;

		var form_data = this.state.form_data, status_messages;

		status_messages = Object.assign({ }, this.state.status_messages);

		Object.keys(response.fields || { }).forEach(function (field, index)
		{
			status_messages[field] = response.fields[field];
		});

		component.setState(
		{
			error: response.error,
			warning: response.warning,
			info: response.info,
			loading: false,
			status_messages: status_messages
		});

		document.location.reload();
	}

	render ()
	{
		const component = this, props = this.props;

		var status_messages = component.state.status_messages;
		var form_data       = component.state.form_data;
		var loader, message, EC_input, EC_message;

		if (component.state.loading === true)
		{
			loader = <Loader className="c-loader" bemit={ ['primary', 'bg-white', 'big'] } />;
		}

		var form_status =
		[
			{ label: 'info', suffix: '--green' },
			{ label: 'warning', suffix: '--orange' },
			{ label: 'error', suffix: '--red' }
		];

		form_status.forEach(function (status, index)
		{
			if (typeof component.state[status.label] !== 'undefined')
			{
				message =
				(
					<div className={ 'c-form-message ' +
						'c-form-message' + status.suffix }>
						<div className="c-form-message__content">
							{ component.state[status.label] }
						</div>
					</div>
				);
			}
		});

		var submit =
		(
			<div className="c-btn-container c-btn-container--form">
				<button type="submit" className="c-btn c-btn--primary c-btn--next"
					onClick={ function (e) { e.target.blur(); } }>
					Mettre à jour
				</button>
			</div>
		);

		var output =
		(
			<div className="u-positioned u-inline-block">

				<Form className="c-form c-form--small u-no-margin-top"
					action="/espace-administrable/couleur"
					data={ form_data }
					onError={ component.handleFailure }
					onValidate={ component.handleValidate }
					onSubmit={ component.handleSubmit }
					history={ props.history }
					hide_button={ true }>

					{ loader }

					<div className="c-title c-title--form">
						<h2 className="c-title__txt">
							Couleur de l'interface
						</h2>
					</div>

					<ColorPicker color={ component.state.form_data['color[main]'] }
						onChange={ component.handleColorChange } />

					<div className="u-margin-top-20">
						<ColorPickerSecondary color={ component.state.form_data['color[main]'] }
							onChangeComplete={ component.handleColorChange } />
					</div>

					{ message }

					{ submit }
				</Form>
			</div>
		);

		return output;
	}
}